"use strict";

import angular from "angular";
import _ from "lodash";
import "./themes/activate-analysis-plus-dialog.scss";
import "./themes/activate-analysis-plus-disalog-dark.scss";

class ActivateAnalysisPlusDialoWarngCtrl {
    hasAccountingAnalysisPlus = false;
    hasAnalaysisPlus = false;
    constructor($mdDialog, locals, $state, $stateParams) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.$state = $state;
        this.$stateParams = $stateParams;
    }

    $onInit() {
        this.hasAccountingAnalysisPlus = this.locals?.hasAccountingAnalysisPlus;
        this.hasAnalaysisPlus = this.locals?.hasAnalaysisPlus;
    }

    onCompanyModel() {
        this.$mdDialog.cancel();

        const url = this.$state.href("nucont.accounting.company", {
            id: "EMPRESA_MODELO",
            accountingId: this.$stateParams?.accountingId
        });

        window.open(url, "_blank");
    }
}

ActivateAnalysisPlusDialoWarngCtrl.$inject = [
    "$mdDialog",
    "locals",
    "$state",
    "$stateParams"
];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("ActivateAnalysisPlusDialoWarngCtrl", ActivateAnalysisPlusDialoWarngCtrl);
